import { render, staticRenderFns } from "./verify-recipe.vue?vue&type=template&id=7b10bf2a&scoped=true&"
import script from "./verify-recipe.vue?vue&type=script&lang=js&"
export * from "./verify-recipe.vue?vue&type=script&lang=js&"
import style0 from "./verify-recipe.vue?vue&type=style&index=0&id=7b10bf2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b10bf2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
